import { Suspense, lazy } from 'react';

const AdminOverview = lazy(() => import('../components/Admin/AdminOverview'));

const AdminOverviewLazy: React.FC = () => {
    return <Suspense><AdminOverview/></Suspense>;
}

export default AdminOverviewLazy;